var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"d-inline-block bg-gray-9 v-align-middle line-height-0 circle",style:({
    width: ((_vm.size || 22) + "px"),
    height: ((_vm.size || 22) + "px")
  }),attrs:{"src":("https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/" + _vm.address + "/logo.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }